export default __webpack_public_path__ + "static/media/review-1.cff789f1.jpeg";